module.exports = __webpack_public_path__ + "img/shoucang1.6121e7cb.png";